import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedActionCard',
  props: {
    buttonId: null,
    lead: null,
    title: null,
    imageSrc: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

/**
 * 完了画面の 1 アクション = 1 バナー（旧 DownloadItem の bnr_item と同じ見た目）。
 * 上にバナー画像、下の薄い水色の帯に小さな前置き＋ピンクの見出し。
 * バナー全体が 1 つの button で、GTM のトリガーが見ている id は必ずこの外側 button に付く
 * （中に button やリンクを入れない。注記リンクは呼び出し側でカードの外に置く）。
 */




return { __sfc: true,emit }
}

})